import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  perfilClearActive,
  perfilStartAdd,
  perfilStartUpdate,
} from "../../../../actions/usuario";
import { Col, Form, Input, Row, Space, Tooltip } from "antd";
import { ButtonUi } from "../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../types/typesConstants";
import { FormItemHiddenUi } from "../../../ui/FormItemHiddenUi";
import { FormUi } from "../../../ui/FormUi";
import { CardUi } from "../../../ui/CardUi";
import { AccesoPerfilDiv } from "./AccesoPerfilDiv";
import { SwitchUi } from "../../../ui/SwitchUi";

const initialValues = {
  id: null,
  nombre: null,
  estado: true,
  accesosgrupo: [],
};
const useResetFormOnClose = ({ form, open, activePerfil }) => {
  const dispatch = useDispatch();
  const prevOpenRef = useRef();
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;

  useEffect(() => {
    if (!open && prevOpen) {
      dispatch(perfilClearActive());
      form.resetFields();
    }
    if (open) {
      //Abrir Modal
      if (activePerfil) {
        //entro editar

        form.setFieldsValue({
          ...activePerfil,
          // accesosgrupo: keysInitialSelected,
        });
      }
    }
  }, [form, prevOpen, open]);
};
export const PerfilScreen = ({ openForm, HandleCloseForm }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [keysCheckedAcceso, setKeysCheckedAcceso] = useState([]);
  const { activePerfil } = useSelector((state) => state.usuario);
  useResetFormOnClose({ form, open: openForm, activePerfil });
  const handleCheckedAcceso = (checkedKeysValue) =>
    setKeysCheckedAcceso(checkedKeysValue);
  const handleCloseFormScreen = () => {
    dispatch(perfilClearActive());
    HandleCloseForm();
  };
  const handleSubmit = (values) => {
    values = {
      ...values,
      accesosgrupo: keysCheckedAcceso?.map((x) => ({
        ruta: x,
      })),
    };
    if (activePerfil) dispatch(perfilStartUpdate(values));
    else dispatch(perfilStartAdd(values));
    handleCloseFormScreen();
  };
  return (
    <>
      <CardUi
        title="Mantenimiento de accesos a perfil"
        size="small"
        extra={
          <Space className="site-button-ghost-wrapper" wrap>
            <Tooltip title="Salir">
              <ButtonUi
                key="cancelar"
                typeUi={TipoButtonConstants.Cancelar}
                onClick={handleCloseFormScreen}
              />
            </Tooltip>
            <Tooltip title="Guardar">
              <ButtonUi
                key="guardar"
                typeUi={TipoButtonConstants.Guardar}
                htmlType="submit"
                form="FormAccesosPerfil"
              />
            </Tooltip>
          </Space>
        }
      >
        <FormUi
          name="FormAccesosPerfil"
          form={form}
          layout="vertical"
          autoComplete="off"
          initialValues={initialValues}
          hideRequiredMark
          handleSubmit={handleSubmit}
        >
          <FormItemHiddenUi name="id" />
          <FormItemHiddenUi name="accesosgrupo" />
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={18} lg={18} xl={18}>
              <Form.Item name="nombre" label="Nombre">
                <Input variant="outlined" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6} xl={6}>
              <Form.Item label="Estado" name="estado" valuePropName="checked">
                <SwitchUi />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[8, 8]} style={{ marginTop: "8px" }}>
            <Col md={24} lg={20} xl={18} xxl={14}>
              <AccesoPerfilDiv
                keysChecked={keysCheckedAcceso}
                onCheck={handleCheckedAcceso}
              />
            </Col>
          </Row>
        </FormUi>
      </CardUi>
    </>
  );
};
